<template>
  <pt-consulting-subscribe-order class="pt-consulting-subscribe-order__page"></pt-consulting-subscribe-order>
</template>

<script>
import PtConsultingSubscribeOrder from 'cps/work-order/pt-consulting-subscribe-order/withData'
export default {
  name: 'pt-consulting-subscribe-order__view',
  components: {
    'pt-consulting-subscribe-order': PtConsultingSubscribeOrder
  }
}
</script>
